import { createSelector } from '@ngrx/store';
import { getCasualTournamentDetails } from './casual-tournament-details/casual-tournament-details.selectors';
import { getPassesLoaded } from './passes/passes.selectors';

export const isPlayReady = createSelector(
  getCasualTournamentDetails,
  getPassesLoaded,
  (tournamentDetails, passesLoaded) =>
    !!tournamentDetails?.lifeExperience && passesLoaded,
);
